import { createContext } from "react";
import { kenzieAPI } from "../requests/api";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useState } from "react";
import { useEffect } from "react";

import { useContext } from "react";
import { TechContext } from "./TechContext";


export const UserContext = createContext({});

const UserProvider = ({children})=>{

    const navigate = useNavigate();
    const [user, setUser] = useState(null);

    const { setTechs } = useContext(TechContext)

    //AUTO-LOGIN//////////////////////////////

    const tokenID = localStorage.getItem("@kenzie-hub: logged-user-token");

    useEffect(()=>{
        if(tokenID){
            getUser();
            navigate("/dashboard")
        }
    },[]);

    const getUser = async()=>{

        try{
            const request = await kenzieAPI.get("/profile",{
                headers:{
                    "Authorization": `Bearer ${tokenID}`
                }
            })
            setUser(request.data);
        }catch(err){                                                                                                            
            console.log(err);
            setUser(null);
        }
    }

    //LOGIN///////////////////////////////////
    const login = async (data)=>{
        try{
            const request = await kenzieAPI.post("/sessions",data);

            localStorage.setItem("@kenzie-hub: logged-user-token", request.data.token);

            navigate("/dashboard");
            setUser(request.data.user);
            setTechs(request.data.user.techs)
        }catch(err){
            console.log(err);
            toast.error("Email ou senha inválidos");
        }
    }

    const submitLogin = (data)=>{
        login(data)
    }


    //REGISTER////////////////////////////////

    const registerUser = async(data)=>{
        try{
            const request = await kenzieAPI.post("/users",data);

            if(request.statusText === "Created"){
                toast.success("Conta criada com sucesso!");
                navigate("/login");
            }
            return request
        }catch(err){
            console.log(err)
            if(err.response.data.message === "Email already exists"){
                toast.error("Este email já está cadastrado")
                return err
            }
            toast.error("Oops! algo deu errado")
        }
    }

    const submitRegister = (data)=>{
        registerUser(data)
    }

    //LEAVE PROFILE
    const leaveProfile = ()=>{
        localStorage.removeItem("@kenzie-hub: logged-user-token");
        navigate("/login");
    }

    return(
        <UserContext.Provider value={{ submitLogin, submitRegister, user, leaveProfile}}>
            {children}
        </UserContext.Provider>
    )

}

export default UserProvider